import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import { LineaEstrategica } from "../models/Maestras/maestras.model";


export const useGestionLineaEstrategica = () => {
    const [cantidadPaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };

    const [lineaEstrategicas, setLineaEstrategicas] = useState<LineaEstrategica[]>([])
    const obtenerLineasEstrategicas = async() => {
        try {
            const lineaEstrategicas = await apiMaestras.obtenerLineaEstrategicas();
            setLineaEstrategicas(lineaEstrategicas);
        } catch (error) {
            console.log(error)
        }
    }

    return {
        cantidadpaginas: cantidadPaginas,
        cambiarCantidadPaginas,
        lineaEstrategicas,
        obtenerLineasEstrategicas
    } 
}
